import { render, staticRenderFns } from "./ModalEditarTermoLGPD.vue?vue&type=template&id=5e0ae91c&scoped=true&"
import script from "./ModalEditarTermoLGPD.vue?vue&type=script&lang=js&"
export * from "./ModalEditarTermoLGPD.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarTermoLGPD.vue?vue&type=style&index=0&id=5e0ae91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0ae91c",
  null
  
)

export default component.exports